import { createContext } from "react";

export const PMDispatchContext = createContext();
